<template>
  <div>
    <b-card title="Payment Recite Form">
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group label="Surgon  Name" label-for="Surgon">
            <b-form-input
              id="Surgon"
              v-model="addForm.surgonName"
              placeholder="Enter Surgon Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Amount" label-for="Amount">
            <b-form-input
              id="Amount"
              type="number"
              v-model="addForm.amount"
              placeholder="Enter Patient Amount"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Surgeryr Name" label-for="Surgeryr">
            <b-form-input
              id="Surgeryr"
              v-model="addForm.surgeryName"
              placeholder="Enter Surgeryr Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Accountant" label-for="Accountant">
            <b-form-input
              id="Accountant"
              v-model="addForm.accountant"
              placeholder="Enter Accountant Name"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printOutClinicRecite()"
        >
          Print Out Clinic Recite Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
    Datepicker,
  },

  data() {
    return {
      addForm: {
        name: '',
        age: '',
        surgonName: '',
        nurseName: '',
        assistantName: '',
        unknown: '',
        unknown2: '',
      },
      errorForm: {
        name: '',
        age: '',
        surgonName: '',
        nurseName: '',
        assistantName: '',
        unknown: '',
      },
    };
  },
  methods: {
    printOutClinicRecite() {
      //
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
